export const generalConstants = {
    SET_DATA_PAGE: 'SET_DATA_PAGE',
};
